export default __webpack_public_path__ + "static/media/t4.b8437e5f.jpeg";